import { REGISTERED_TYPE, SANSHO_LEVEL, Sites } from 'constant';
import { Layout, LayoutProps } from 'containers';
import { toast } from 'react-toastify';
import NewentrantSendoff from 'pages/NewentrantSendoff';
// 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
import EducationStatus from 'pages/EducationStatus';
import SendPhoto from 'pages/EducationStatus/SendPhoto';
// 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
import MapSite from 'containers/MapSite';
import { routes } from 'navigations/routers';
import { FC, useCallback, useEffect } from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import type { AppDispatch } from 'redux/store';
import { getStatusApproved } from '../../SiteDetail/thunk';
import { getMapSite, getUserSiteCharge } from '../../../containers/SiteList/thunk';
import ApprovedSites from './ApprovedSites';
import SectionStyled from './styles';
import UnapprovedSites from './UnapprovedSites';

const Home: FC = () => {
  const history = useHistory();
  const { entity = Sites.UNAPPROVED } = useParams<{ entity: Sites }>();
  const dispatch = useDispatch<AppDispatch>();
  const fetchApi = useCallback(async () => {
    switch (entity) {
      case Sites.UNAPPROVED:
        return dispatch(getStatusApproved({}));
      case Sites.APPROVED:
        return dispatch(
          getUserSiteCharge({
            sansho_level: SANSHO_LEVEL.CM_02_02,
            registered_type: REGISTERED_TYPE.CM_02_02,
          })
        );
      case Sites.MAP:
        const resultAction = await dispatch(
          getMapSite({
            sansho_level: '0',
            registered_type: 2,
          })
        );
        if (getMapSite.rejected.match(resultAction)) {
          const payload = resultAction.payload as { message?: string };
          toast.error(payload?.message || 'エラーが発生しました。');
        }
        return resultAction;
      default:
        return;
    }
  }, [dispatch, entity]);

  useEffect(() => {
    fetchApi();
  }, [fetchApi]);

  const handleSelectedTab = useCallback(
    (entity) => {
      return history.replace(generatePath(routes.Home.path, { entity }));
    },
    [history]
  );

  return (
    <SectionStyled>
      <Layout
        tabs={tabs}
        defaultValue={entity}
        showNotification={false}
        onSelected={handleSelectedTab}
        left
        right
      />
      {entity === Sites.UNAPPROVED && <UnapprovedSites />}
      {entity === Sites.APPROVED && <ApprovedSites />}
      {entity === Sites.MAP && <MapSite />}
      {/* 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start */}
      {entity === Sites.EducationStatus && <EducationStatus />}
      {/* 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end */}
      {entity === Sites.NEW_ENTRANTSENDOFF && <NewentrantSendoff />}
      {/* 2024/01/03 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start */}
      {entity === Sites.SendPhoto && <SendPhoto />}
      {/* 2024/01/03 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 end */}
    </SectionStyled>
  );
};

const tabs: LayoutProps['tabs'] = [
  { label: '未承認現場一覧', key: Sites.UNAPPROVED },
  { label: '現場一覧', key: Sites.APPROVED },
  { label: 'マップ', key: Sites.MAP },
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ start
  // 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
  // 2024/03/28 Leading Win 教育機能の非表示 start
  // { label: '新規・送出', key: Sites.EducationStatus },
  // 2024/03/28 Leading Win 教育機能の非表示 end
  // 2024/01/02 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ end
];

export default Home;
